export default __webpack_public_path__ + "static/media/make_it_happen.6e181763.png";